import { forwardRef, type Ref, type SVGProps } from "react";
const IconCompassFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2m7.07 13.77L18 18l-2.23 5.07a1.49 1.49 0 0 1-1.38.93h-.1A1.49 1.49 0 0 1 13 22.9l-2.9-11a1.52 1.52 0 0 1 .38-1.42 1.55 1.55 0 0 1 1.01-.48 1.6 1.6 0 0 1 .37.05l11 2.9a1.49 1.49 0 0 1 .17 2.82z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconCompassFilledSVG);
ForwardRef.displayName = "IconCompassFilled";
export { ForwardRef as IconCompassFilled };
